import { useContext } from "react";
import { Button } from "react-bootstrap";
import { IoLogInOutline } from "react-icons/io5";
import TooltipConfig from "../../../components/Tooltip";
import { AuthContext } from "../../../contexts/Authentication/AuthContext";
import "./styles.css";

const Logout = ({ TextLogout }: { TextLogout?: string }) => {
  const { signOut} = useContext(AuthContext);
  const { isAuthenticated } = useContext(AuthContext);

  const logout = () => {
    signOut();
  };

  return isAuthenticated ? (
    <TooltipConfig
      content={["Sair"]}
      children={
        <Button
          type="button"
          variant="link"
          className="button-logout"
          style={{ fontSize: "1.2rem" }}
          onClick={logout}
        >
          <div className="display-flex">
            <IoLogInOutline />
            {TextLogout ? <div className="px-2">{TextLogout}</div> : ""}
          </div>
        </Button>
      }
      placement={"bottom"}
      style={true}
    />
  ) : (
    <></>
  );
};

export default Logout;
